import { useEffect, useRef, useState } from "react"

const ActionDropdown = ({ buttonLabel = "Invoice", className = "btn btn-sm btn-primary btn-light dropdown-toggle-btn", children }) => {
  const [open, setOpen] = useState(false)
  const ref = useRef(null)

  // Close on outside click
  useEffect(() => {
    const handleClickOutside = e => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false)
      }
    }
    document.addEventListener("mousedown", handleClickOutside)
    return () => document.removeEventListener("mousedown", handleClickOutside)
  }, [])

  return (
    <div className="custom-dropdown" ref={ref}>
      <button
        type="button"
        className={className}
        onClick={e => {
          e.stopPropagation()
          setOpen(prev => !prev)
        }}
      >
        {buttonLabel} <i className="mdi mdi-dots-vertical" />
      </button>

      {open && <div className="custom-dropdown-menu">{children}</div>}
    </div>
  )
}

export default ActionDropdown
